<template>
  <div class="pageStyle">
    <fieldset style="background: none; border: none">
      <legend>{{ $t("currencyLabel") }}</legend>
      <div class="toggle">
        <input
          type="radio"
          name="currency"
          value="EGP"
          id="EGP"
          checked="checked"
          v-model="selectedCurrency"
          @change="fetchData"
        />
        <label for="EGP">{{ $t("EGP") }}</label>
        <input
          type="radio"
          name="currency"
          value="USD"
          id="USD"
          v-model="selectedCurrency"
          @change="fetchData"
        />
        <label for="USD">{{ $t("USD") }}</label>
      </div>
    </fieldset>
    <div
      :class="{
        'card container cardContainer': langVar === 'ar',
        'card container cardContainer cardContainerEn': langVar === 'en',
      }"
    >
      <div
        :class="{
          'product-details container': langVar === 'ar',
          'product-details product-details-en container': langVar === 'en',
        }"
      >
        <div class="product-imagee">
          <img :src="product.imagee" :alt="product.name" class="product-img" />
        </div>
        <div
          class="offerClass offerClassDetails"
          style="top: 11%; border-top-right-radius: 15px; width: 12%"
          v-if="product.offer"
        >
          <p style="padding-top: 10px">
            <span class="offerClassSpan2">{{ product.offer }}%</span>
          </p>
        </div>
        <div class="product-info m-5">
          <h1 class="product-title">{{ product.name }}</h1>
          <div class="product-description">
            <h3 class="description-heading">{{ $t("description") }}</h3>
            <p class="description-text">
              {{ product.multilingualData.description }}
            </p>
          </div>
          <div class="product-details-list">
            <ul>
              <li>
                <strong style="color: rgb(103, 101, 101)"
                  >* {{ product.multilingualData.execute }}</strong
                >
              </li>
              <li>
                <strong>{{ $t("height") }}:</strong>
                {{ product.height }} {{ $t("cm") }}
              </li>
              <li>
                <strong>{{ $t("depth") }}:</strong>
                {{ product.depth }} {{ $t("cm") }}
              </li>
              <li>
                <strong>{{ $t("style") }}:</strong>
                {{ product.multilingualData.style }}
              </li>
              <!-- <li>
                <strong>{{ $t("price") }}:</strong>
                <span v-if="langVar === 'ar'">
                  <span :class="{ product_old_price: product.offer }">
                    {{ product.multilingualData.price }}
                    <span v-if="selectedCurrency == 'USD'">دولار</span>
                    <span v-if="selectedCurrency == 'EGP'">ج.م</span>
                  </span>

                  <span v-if="product.offer">
                    <span style="font-weight: 800; margin: 3%"
                      >{{ product.PriceAfterOffer }}
                      <span v-if="selectedCurrency == 'USD'">دولار</span>
                      <span v-if="selectedCurrency == 'EGP'">ج.م</span></span
                    >
                  </span>
                </span>
                <span v-if="langVar === 'en'">
                  <span :class="{ product_old_price: product.offer }">
                    {{ product.multilingualData.price }}
                    {{ selectedCurrency }}
                  </span>
                  <span v-if="product.offer">
                    <span style="font-weight: 800; margin: 3%"
                      >{{ product.PriceAfterOffer }}
                      {{ selectedCurrency }}</span
                    >
                  </span>
                </span>
              </li> -->
              <li>
                <strong>{{ $t("category") }}:</strong> {{ categoryName }}
              </li>
            </ul>
            <div class="row container">
              <div class="col-md-12">
                <table class="table materialsTable rounded">
                  <thead>
                    <tr>
                      <th style="text-align: center !important">
                        {{ $t("material") }}
                      </th>
                      <th style="text-align: center !important">
                        {{ $t("price") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="materialPrice in product.ProductMaterialPrices"
                      :key="materialPrice.Material.id"
                    >
                      <td>{{ materialPrice.Material.name }}</td>
                      <td>
                        {{ materialPrice.price }}&nbsp;<span
                          v-if="selectedCurrency == 'USD'"
                          >{{ $t("USD") }}</span
                        >
                        <span v-if="selectedCurrency == 'EGP'">{{
                          $t("EGP")
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Related Products -->
    <div class="container row relatedRow">
      <h1 class="relatedTitle">{{ $t("relatedProducts") }}</h1>
      <div
        v-for="(item, index) in relatedProducts"
        :key="index"
        class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
      >
        <div class="full">
          <div class="product_blog2">
            <div class="feature_icon">
              <a style="cursor: pointer" @click="productDetails(item.id)">
                <img
                  :src="item.imagee"
                  :alt="item.name"
                  class="card-img card-img-product"
                />
              </a>
            </div>
            <div class="product_title" v-if="langVar">
              <a style="cursor: pointer" @click="productDetails(item.id)">
                <i class="fas fa-info-circle"></i>
                {{ item.name }}
              </a>
            </div>

            <div class="offerClass" v-if="item.offer">
              <p style="padding-top: 10px">
                <span class="offerClassSpan2">{{ item.offer }}%</span>
              </p>
            </div>
            <div v-if="langVar === 'ar'">
              <div :class="{ product_old_price: item.offer }">
                {{ item.ProductMaterialPrices[0].price }}
                <span v-if="selectedCurrency == 'USD'">{{ $t("USD") }}</span>
                <span v-if="selectedCurrency == 'EGP'">{{ $t("EGP") }}</span>
              </div>
              <div v-if="item.offer">
                السعر بعد الخصم:
                <span style="font-weight: 800"
                  >{{ item.ProductMaterialPrices[0].PriceAfterOffer }}
                  <span v-if="selectedCurrency == 'USD'">{{ $t("USD") }}</span>
                  <span v-if="selectedCurrency == 'EGP'">{{
                    $t("EGP")
                  }}</span></span
                >
              </div>
            </div>
            <div v-if="langVar === 'en'">
              <div :class="{ product_old_price: item.offer }">
                {{ item.ProductMaterialPrices[0].price }}
                {{ selectedCurrency }}
              </div>
              <div v-if="item.offer">
                Price After Offer:
                <span style="font-weight: 800"
                  >{{ item.ProductMaterialPrices[0].PriceAfterOffer }}
                  {{ selectedCurrency }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "../../Axios";
import { mapState } from "vuex";
import store from "../../store";

export default {
  data() {
    return {
      langVar: store.state.currentLang,
      product: {
        name: "",
        description: "",
        height: "",
        depth: "",
        material: "",
        style: "",
        price: "",
        categoryId: "",
        imagee: "",
      },
      categoryName: "",
      relatedProducts: "",
      selectedCurrency: "EGP",
    };
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
  },
  methods: {
    fetchData() {
      const id = this.$route.params.id;

      Axios.get("/product/" + id, {
        headers: {
          currency: this.selectedCurrency,
        },
      })
        .then((response) => {
          // console.log("aaaa", response.data.data);
          this.product = response.data.data;
          // console.log(this.product);
          if (
            this.product.imagee &&
            this.product.imagee.type === "Buffer" &&
            Array.isArray(this.product.imagee.data)
          ) {
            const buffer = Buffer.from(this.product.imagee.data);
            const base64imagee = buffer.toString("base64");
            this.product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
          }
          this.relatedProducts = response.data.related.map((product) => {
                if (
                  product.imagee &&
                  product.imagee.type === "Buffer" &&
                  Array.isArray(product.imagee.data)
                ) {
                  const buffer = Buffer.from(product.imagee.data);
                  const base64imagee = buffer.toString("base64");
                  product.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
                }
                return {
                  icon: product.icon,
                  name: product.name,
                  description: product.description,
                  price: product.price,
                  imagee: product.imagee,
                  offer: product.offer,
                  PriceAfterOffer: product.PriceAfterOffer,
                  id: product.id,
                  ProductMaterialPrices: product.ProductMaterialPrices,
                };
              });
          if (
            this.relatedProducts.image &&
            this.relatedProducts.image.type === "Buffer" &&
            Array.isArray(this.relatedProducts.imagee.data)
          ) {
            const buffer = Buffer.from(this.relatedProducts.image.data);
            const base64imagee = buffer.toString("base64");
            this.relatedProducts.imagee = `data:imagee/jpeg;base64,${base64imagee}`; // Adjust MIME type if needed
          }
          // console.log("related, ", this.relatedProducts);
          Axios.get(`/category/${this.product.categoryId}`, {
            headers: {
              currency: this.selectedCurrency,
            },
          })
            .then((categoryResponse) => {
              // this.categoryName = categoryResponse.data.data.category.name;
              this.categoryName = categoryResponse.data.data.categoryData.name;

              // console.log(this.categoryName, "kjjjjjj");
            })
            .catch((error) => {
              // console.error(error);
            });
        })
        .catch((error) => {
          // console.error(error);
        });
    },
    productDetails(item) {
      this.$router.push("/product-details/" + item);
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.fetchData();
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.offerClassDetails {
  top: 11% !important;
  right: 2.75% !important;
  width: 15% !important;
  text-align: center;
}

.pageStyle {
  background-image: url(../../assets/images/background.png);
  background-size: cover;
  padding-top: 10%;
}

.product-details {
  display: flex;
  text-align: right;
  margin: 50px 20px;
}

.product-details-en {
  text-align: left;
  direction: ltr;
}

.product-imagee {
  flex: 1;
}

.product-img {
  max-width: 500px;
  max-height: 100%;
  border-radius: 15px;
}

.product-info {
  flex: 2;
  padding: 0 20px;
}

.product-title {
  margin-bottom: 10px;
  font-weight: 800;
}

.description-heading {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}

.description-text {
  font-size: 16px;
}

.product-details-list {
  margin-top: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  font-size: 16px;
  margin-bottom: 5px;
}

strong {
  font-weight: bold;
}

.cardContainer {
  border-radius: 30px;
  box-shadow: 5px 10px 18px #888888;
  background-color: rgba(255, 255, 255, 0.495);
  background-image: url("../../assets/images/logo3ar.png");
  background-size: 220px;
  background-position-x: 10%;
  background-position-y: 25px;
  background-repeat: no-repeat;
}

.cardContainerEn {
  background-position-x: 85%;
  background-image: url("../../assets/images/logo3.png");
}

.cardContainer:hover {
  background-color: rgba(255, 255, 255, 0.732);
}

.relatedRow {
  margin: auto;
}

.relatedTitle {
  text-align: center;
  margin-top: 70px;
  margin-bottom: 40px;
  font-weight: 800;
  font-size: 40px;
  color: #b5aaa3;
  text-shadow: 0 2px 2px #444;
}

@media (max-width: 900px) {
  .offerClassDetails {
    top: 6% !important;
    right: 22% !important;
    width: 15% !important;
  }

  .product-img {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    border-radius: 15px;
  }

  .product-details {
    display: block;
    margin: 50px 0px;
  }

  .product-imagee {
    max-width: 400px;
    margin: auto;
  }

  .product-info {
    margin-top: 20px;
  }

  .product-title {
    text-align: center;
    margin-bottom: 20px;
  }

  .cardContainer {
    background-position-y: 95%;
    background-position-x: 45%;
  }
}

@media (max-width: 770px) {
  .offerClassDetails {
    right: 8% !important;
    width: 25% !important;
  }
}
</style>
